'use strict';

var s=class{items;constructor(){this.items=[];}AddItem(t,i){this.items.push({id:t,data:i});}DeleteItem(t){let i=this.items.filter(e=>e.id!==t);this.items=i;}UpdateItem(t,i){let e=this.items.findIndex(n=>n.id===t);this.items[e]=i;}FindItem(t){return this.items.find(i=>i.id===t)}};

exports.a = s;
